@if (!!deliveryDate) {
<div class="delivery-date">
  {{ deliveryDate | TimeZonedDate }}
</div>
}
